<script>
import { mapState, mapMutations } from "vuex";
import UrgencyStartForm from "@/components/ContractModals/Components/BaseParts/UrgencyStartForm";

export default {
  extends: UrgencyStartForm,
  computed: {
    ...mapState("QuotationContractModal", ["quantity", "textHint"])
  },
  methods: {
    ...mapMutations("QuotationContractModal", ["setQuantity", "setTextHint"])
  }
};
</script>
